import { hydrateRoot } from 'react-dom/client';

import { Application } from 'shared/containers/App';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ERuntimeSettings } from '../../../shared/types/runtimeSettings';
import { loadableReady } from '@loadable/component';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies): void {
  const { store, context } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>(ERuntimeSettings.projectName);
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  loadableReady(() => {
    hydrateRoot(rootElement, <Application context={context} reduxStore={store} />);
  });
}
